import React from 'react'
const InlineError = ({text}) =>  <div style={{color: "#FF9494", fontSize:"13px", fontWeight:"500"}}>{text}</div>
export default InlineError;